import React, { Suspense } from 'react';

export const TrialComponent = React.lazy(() => import('./Trial'));

export const Trial = () => (
  <Suspense fallback={null}>
    <TrialComponent />
  </Suspense>
);
